import React from 'react'
import { useNavigate } from 'react-router-dom'

import Button, { type ButtonProps } from '../button'

export type ButtonLinkProps = ButtonProps & {
  params?: Record<string, any>
  path: string
}

// a Button that navigates to `path` after its own onPress
function ButtonLink({ params, path, onPress, ...props }: ButtonLinkProps) {
  const navigate = useNavigate()
  const pressHandler = (event: React.SyntheticEvent) => {
    onPress?.(event)
    navigate(path)
  }
  return <Button accessibilityRole='link' onPress={pressHandler} {...props} />
}

export default ButtonLink
